import React from 'react';
import { ContentTemplate, HeaderTemplate, Stepper, TitleHeader } from 'web-library';

import { useTranslation } from 'react-i18next';
import ReviewSubject from '../../modules/subject/components/ReviewSubject';
import ExamDraftMessage from '../../modules/examRegistration/components/ExamDraftMessage';
import ExamTypeUuidDisplay from '../../modules/examRegistration/components/ExamTypeUuidDisplay';

interface ReviewSubjectPageProps {
  routeSteps: { label: string }[];
  isGroup?: boolean;
}

const ReviewSubjectPage = ({ routeSteps, isGroup = false }: ReviewSubjectPageProps) => {
  const { t } = useTranslation();

  const title: string = isGroup
    ? t('amendment->>GroupSubjectAmendment.NewSubjectAmendment')
    : t('amendment->>SubjectAmendment.Subject Amendment');
  const activeStep: number = isGroup ? 3 : 2;

  return (
    <>
      <TitleHeader title={title} />
      <HeaderTemplate>
        {isGroup && <ExamTypeUuidDisplay />}
        <Stepper activeStep={activeStep} steps={routeSteps} />
      </HeaderTemplate>
      <ContentTemplate type="full">
        <ReviewSubject
          translations={{
            subjectName: t('amendment->>SubjectAmendment.Subject Name'),
            subjectCode: t('amendment->>SubjectAmendment.Subject Code'),
            subjectLevel: t('amendment->>SubjectAmendment.Subject Level'),
            examSeries: t('amendment->>SubjectAmendment.Exam Series'),
            examLevel: t('amendment->>SubjectAmendment.Exam Level'),
            languageMedium: t('amendment->>SubjectAmendment.Language Medium'),
            actionTaken: t('amendment->>SubjectAmendment.Action Taken'),
          }}
          isGroup={isGroup}
        />
        <ExamDraftMessage />
      </ContentTemplate>
    </>
  );
};

export default ReviewSubjectPage;
